import React, { useEffect } from "react";
import { STORE } from "@/config";

const CONTENT = {
  shipping: {
    title: "Shipping & Delivery",
    sections: [
      ["Order Processing", "All orders are confirmed and processed within 24 hours of successful payment. Orders placed on Sundays or public holidays are processed the next working day."],
      ["Packaging", "Every product is vacuum-sealed in food-grade, hygienic packaging to lock in freshness and preserve the natural taste and aroma of our dry fruits."],
      ["Shipping", "We ship across all serviceable pincodes in India through trusted courier partners. Free shipping applies on all orders above ₹1500. A flat shipping charge of ₹60 applies to orders below ₹1500."],
      ["Estimated Delivery", "Metro cities: 2–4 business days. Rest of India: 4–7 business days. Remote locations may take slightly longer."],
      ["Order Tracking", "Once dispatched, you will receive a tracking link via WhatsApp and email so you can follow your order until it reaches your door."],
    ],
  },
  refund: {
    title: "Cancellation & Refund Policy",
    sections: [
      ["Order Cancellation", "Orders can be cancelled within 12 hours of placement, provided they have not yet been dispatched. To cancel, contact us on WhatsApp or email with your Order ID."],
      ["Damaged or Wrong Items", "If you receive a damaged, defective or incorrect product, please notify us within 48 hours of delivery with photos. We will arrange a replacement or refund."],
      ["Refund Process", "Approved refunds are processed to the original payment method within 5–7 business days. Prepaid orders are fully refundable in eligible cases."],
      ["Non-Returnable", "Due to the perishable nature of food products, opened or partially consumed items are not eligible for return unless there is a quality issue."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Information We Collect", "We collect your name, contact number, email and delivery address solely to process and deliver your orders."],
      ["How We Use It", "Your information is used only for order fulfilment, delivery updates and customer support. We never sell or rent your data to third parties."],
      ["Payment Security", "All online payments are processed through secure, encrypted payment gateways. We do not store your card or banking details."],
      ["Cookies", "We use minimal cookies to improve your browsing experience and remember your cart."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting us."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Acceptance", "By using this website and placing an order, you agree to these terms and conditions."],
      ["Products & Pricing", "All prices are listed in INR and inclusive of applicable taxes. We reserve the right to modify prices and product availability without prior notice."],
      ["Orders", "We reserve the right to accept or decline any order. Order confirmation is subject to payment verification and stock availability."],
      ["Prepaid Store", "This is a prepaid store. Payments are accepted online (card/UPI), via UPI QR, or through WhatsApp-guided payment. Cash on Delivery is not available."],
      ["Limitation of Liability", "We are not liable for delays caused by courier partners, incorrect addresses, or circumstances beyond our reasonable control."],
    ],
  },
};

export default function PolicyPage({ kind }) {
  const data = CONTENT[kind];
  useEffect(() => window.scrollTo(0, 0), [kind]);
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12">
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#1F130B]">{data.title}</h1>
      <p className="text-sm text-[#6B5B52] mt-2">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}</p>
      <div className="mt-8 space-y-7">
        {data.sections.map(([t, d], i) => (
          <div key={i}>
            <h2 className="font-display text-xl font-semibold text-[#1F130B]">{i + 1}. {t}</h2>
            <p className="mt-2 text-[#6B5B52] leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 rounded-2xl bg-white border border-[#E7E0D6] p-6">
        <p className="text-sm text-[#6B5B52]">Questions? Reach us at <a href={`mailto:${STORE.email}`} className="text-[#C2410C] font-semibold">{STORE.email}</a> or call <span className="text-[#1F130B] font-semibold">{STORE.phone}</span>.</p>
      </div>
    </div>
  );
}
